(function () {
  if (window.__BRUDON_FRETE_PRODUTO_V2__) return;
  window.__BRUDON_FRETE_PRODUTO_V2__ = true;

  function digitsOnly(s) { return (s || "").replace(/\D/g, ""); }
  function formatCep(value) {
    var s = digitsOnly(value).slice(0, 8);
    if (s.length <= 5) return s;
    return s.slice(0, 5) + "-" + s.slice(5);
  }

  async function viaCep(zipDigits) {
    var r = await fetch("https://viacep.com.br/ws/" + zipDigits + "/json/");
    var j = await r.json();
    if (j && j.erro) throw new Error("Digite um CEP válido. Ex.: 88888-888");
    return j;
  }

  async function fetchJson(url, opts) {
    var res = await fetch(url, Object.assign({
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "X-Requested-With": "xmlhttprequest" }
    }, opts || {}));
    var data = await res.json();
    if (!res.ok) throw data;
    return data;
  }

  function setBusy(root, text) {
    var btn = root.querySelector("button");
    var loading = root.querySelector(".loading");
    var result = root.querySelector(".result");
    if (btn) btn.setAttribute("aria-busy", "true");
    if (loading) loading.textContent = text || "Calculando…";
    if (result) { result.hidden = true; result.innerHTML = ""; }
  }

  function clearBusy(root) {
    var btn = root.querySelector("button");
    var loading = root.querySelector(".loading");
    if (btn) btn.removeAttribute("aria-busy");
    if (loading) loading.textContent = "";
  }

  function renderError(root, msg) {
    var loading = root.querySelector(".loading");
    var result = root.querySelector(".result");
    if (loading) loading.textContent = "";
    if (result) {
      result.hidden = false;
      result.innerHTML = '<span class="error">' + msg + "</span>";
    }
  }

  function renderRates(root, rates, city, state) {
    var html = "";
    html += '<div class="heading">Opções de entrega para ' + city + " - " + state + "</div>";
    html += '<div class="shipping-rates"><div class="rates">';

    rates.forEach(function (r) {
      var price = parseFloat(r.price || 0);
      var priceLabel = price === 0
        ? "<strong>Grátis</strong>"
        : price.toLocaleString("pt-br", { style: "currency", currency: "BRL" });

      var days = (r.delivery_days && r.delivery_days[0] != null) ? r.delivery_days[0] : null;
      var prazo = (days != null) ? ("receba em <b>" + days + "</b> dias úteis") : "prazo informado no checkout";

      html += '<div class="rate"><div class="rate__info">';
      html += (r.presentment_name || "Entrega") + ': <span><b>' + priceLabel + "</b> " + prazo + "</span>";
      html += "</div></div>";
    });

    html += "</div></div>";

    var result = root.querySelector(".result");
    if (result) {
      result.hidden = false;
      result.innerHTML = html;
    }
  }

  function getQty() {
    var qtyEl = document.querySelector(".quantity__input, .quantity-input__element");
    var qty = qtyEl ? parseInt(qtyEl.value || "1", 10) : 1;
    return isNaN(qty) || qty < 1 ? 1 : qty;
  }

  async function snapshotCart() {
    return await fetchJson("/cart.js", { method: "GET", headers: { "X-Requested-With": "xmlhttprequest" } });
  }

  async function clearCart() {
    await fetchJson("/cart/clear.js", { method: "POST", body: JSON.stringify({}) });
  }

  async function restoreCart(snapshot) {
    if (!snapshot || !Array.isArray(snapshot.items) || snapshot.items.length === 0) return;

    // restaura item a item
    for (var i = 0; i < snapshot.items.length; i++) {
      var it = snapshot.items[i];
      if (!it || !it.id || !it.quantity) continue;
      await fetchJson("/cart/add.js", {
        method: "POST",
        body: JSON.stringify({ id: it.id, quantity: it.quantity })
      });
    }
  }

  async function addOnlyThisVariant(variantId, qty) {
    await fetchJson("/cart/add.js", {
      method: "POST",
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
  }

  async function getShippingRates(country, province, zip) {
    var params = new URLSearchParams();
    params.set("shipping_address[country]", country);
    params.set("shipping_address[province]", province);
    params.set("shipping_address[zip]", zip);
    var url = "/cart/shipping_rates.json?" + params.toString();
    return await fetchJson(url, { method: "GET", headers: { "X-Requested-With": "xmlhttprequest" } });
  }

  function initOne(root) {
    var input = root.querySelector(".cep-estimate");
    var btn = root.querySelector("button");
    var result = root.querySelector(".result");
    if (!input || !btn || !result) return;

    // só em página de produto
    if (!document.querySelector('input[name="id"]')) return;

    // cache CEP
    try {
      var saved = localStorage.getItem("cepCache");
      if (saved) input.value = formatCep(saved);
    } catch (_) {}

    // máscara
    input.setAttribute("inputmode", "numeric");
    input.setAttribute("autocomplete", "postal-code");
    input.setAttribute("maxlength", "9");
    input.addEventListener("input", function () {
      var masked = formatCep(input.value);
      if (input.value !== masked) input.value = masked;
    });

    async function calculate() {
      var zipDigits = digitsOnly(input.value).slice(0, 8);
      if (zipDigits.length !== 8) {
        renderError(root, "Digite um CEP com 8 números. Ex.: 88888-888");
        return;
      }

      try { localStorage.setItem("cepCache", zipDigits); } catch (_) {}

      var variantId = parseInt(document.querySelector('input[name="id"]').value, 10);
      if (!variantId) {
        renderError(root, "Não foi possível identificar a variação do produto.");
        return;
      }

      var qty = getQty();

      var cartSnapshot = null;

      try {
        setBusy(root, "Calculando frete…");

        var addr = await viaCep(zipDigits);
        var province = addr.uf || "";
        var city = addr.localidade || "";

        setBusy(root, "Calculando frete para " + city + " - " + province + "…");

        // ✅ ISOLAMENTO: snapshot -> clear -> add 1 item -> rates -> restore
        cartSnapshot = await snapshotCart();
        await clearCart();
        await addOnlyThisVariant(variantId, qty);

        var ratesResp = await getShippingRates("Brazil", province, zipDigits);
        var rates = ratesResp && ratesResp.shipping_rates ? ratesResp.shipping_rates : [];

        if (!rates.length) throw new Error("Nenhum método de entrega encontrado. Confira se o CEP informado é válido.");

        renderRates(root, rates, city, province);
      } catch (err) {
        renderError(root, (err && err.message) ? err.message : "Erro ao calcular o frete.");
      } finally {
        // ✅ restaura carrinho SEMPRE
        try {
          await clearCart();
          await restoreCart(cartSnapshot);
        } catch (_) {}
        clearBusy(root);
      }
    }

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      calculate();
    });

    input.addEventListener("keypress", function (e) {
      if (e.which === 13 || e.key === "Enter") {
        e.preventDefault();
        calculate();
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".shipping-estimate").forEach(initOne);
  });
})();
